import { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../providers';
import { PostContext } from '../providers';
import {
  editProfile,
  fetchUserFriends,
  getPosts,
  login as userLogin,
  register,
} from '../api';
import {
  getItemFromLocalStorage,
  LOCALSTORAGE_TOKEN_KEY,
  removeItemFromLocalStorage,
  setItemInLocalStorage,
} from '../utils';
import jwt from 'jwt-decode';

export const useAuth = () => {
  return useContext(AuthContext);
};

export const useProvideAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUser = async () => {
      const userToken = getItemFromLocalStorage(LOCALSTORAGE_TOKEN_KEY);

      if (userToken) {
        const user = jwt(userToken);
        const response = await fetchUserFriends();

        let friends = [];

        if (response.success) {
          friends = response.data.friends;
        }

        setUser({
          ...user,
          friends,
        });
      }
      setLoading(false);
    };

    getUser();
  }, []);

  // const login = async (email, password) => {
  //   const response = await userLogin(email, password);

  //   if (response.success) {
  //     // setUser(response.data);
  //     setUser(response.data.user);
  //     setItemInLocalStorage(
  //       LOCALSTORAGE_TOKEN_KEY,
  //       response.data.token ? response.data.token : null
  //     );
  //     return {
  //       success: true,
  //     };
  //   } else {
  //     return {
  //       success: false,
  //       message: response.message,
  //     };
  //   }
  // };

  const login = async (email, password) => {
    const response = await userLogin(email, password);

    if (response.success) {
      // setUser(response.data);
      setItemInLocalStorage(
        LOCALSTORAGE_TOKEN_KEY,
        response.data.token ? response.data.token : null
      );
      const response2 = await fetchUserFriends();

      let friends = [];

      if (response2.success) {
        friends = response2.data.friends;
      }

      response.data.user.friends = friends;
      setUser(response.data.user);

      return {
        success: true,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  };

  const logout = () => {
    setUser(null);
    removeItemFromLocalStorage(LOCALSTORAGE_TOKEN_KEY);
  };

  const signup = async (name, email, password, confirmPassword) => {
    const response = await register(name, email, password, confirmPassword);
    if (response.success) {
      return {
        success: true,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  };
  const updateUser = async (userId, name, password, confirmPassword) => {
    const response = await editProfile(userId, name, password, confirmPassword);

    if (response.success) {
      setUser(response.data.user);
      setItemInLocalStorage(
        LOCALSTORAGE_TOKEN_KEY,
        response.data.token ? response.data.token : null
      );

      return {
        success: true,
      };
    } else {
      return {
        success: false,
        message: response.message,
      };
    }
  };

  const updateUserFriends = (addFriend, friend) => {
    if (addFriend) {
      setUser({
        ...user,
        friends: [...user.friends, friend],
      });
      return;
    }
    const newFriend = user.friends.filter(
      (f) => f.to_user._id !== friend.to_user._id
    );

    setUser({
      ...user,
      friends: newFriend,
    });
  };

  return {
    user,
    login,
    logout,
    signup,
    loading,
    updateUser,
    updateUserFriends,
  };
};

export const usePosts = () => {
  return useContext(PostContext);
};

export const useProvidePosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      const response = await getPosts();

      if (response.success) {
        setPosts(response.data.posts);
      }

      setLoading(false);
    };

    fetchPosts();
  }, []);

  const addPostToState = (post) => {
    const newPosts = [post, ...posts];
    setPosts(newPosts);
  };

  const addComment = (comment, postId) => {
    const newPost = posts.map((post) => {
      if (post._id === postId) {
        return { ...post, comments: [...post.comments, comment] };
      }
      return post;
    });
    setPosts(newPost);
  };
  return {
    data: posts,
    loading,
    addPostToState,
    addComment,
  };
};
